module.exports = __webpack_public_path__ + "assets/img/tab2.d577ef40.png";